import * as React from "react";

function MountainIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M503.2 393.8 280.1 44.25C274.9 36.08 265.4 32 256 32c-9.4 0-18.9 4.08-24.1 12.25L8.807 393.8a55.906 55.906 0 0 0-1.666 57.45C17.07 468.1 35.92 480 56.31 480h399.4c20.39 0 39.24-11.03 49.18-28.77 10.01-18.03 9.41-40.03-1.69-57.43zM256 95.74 327.7 208H256a24.033 24.033 0 0 0-19.2 9.594L208 256l-29.3-39.1L256 95.74zM462.1 427.8c-.6 2.5-3.4 4.2-6.4 4.2H56.31c-2.996 0-5.857-1.654-7.283-4.201-1.461-2.609-1.373-5.672.234-8.189L151.1 260.1l37.72 50.29C193.3 316.4 200.5 320 208 320s14.67-3.562 19.2-9.594L268 256h90.3l104.4 163.6c1.6 2.5 1.7 5.6-.6 8.2z"
  }));
}

const ForwardRef = React.forwardRef(MountainIcon);
export default ForwardRef;